import {getClient, getClientList} from '../../services/ClientService';

export default {
  namespaced: true,
  state: {
    adminClientList: [],
    currentClient: null,
    currentClientName: null,
    clientLoaded: false,
    initialClient: null
  },
  getters: {
    clientList: (state) => {
      return state.adminClientList;
    },
    currentClient: (state) => {
      return state.currentClient;
    },
    currentClientName: (state) => {
      return state.currentClient !== null ? state.currentClient.companyName : null;
    },
    clientActive: (state) => {
      return state.currentClient !== null;
    },
    initialClient: (state) => {
      return state.initialClient;
    },
    clientLoaded: (state) => {
      return state.clientLoaded;
    }, // REVIEW Do we use this for anything??
    clientEdited: (state) => {
      if (state.initialClient && state.currentClient) {
        for (let key of Object.keys(state.currentClient)) {
          let editValue = state.currentClient[key] ? String(state.currentClient[key]).toLowerCase() : '';
          let initialValue = state.initialClient[key] ? String(state.initialClient[key]).toLowerCase() : '';
          if (editValue !== initialValue) {
            return true;
          }
        }
      }
      return false;
    }
  },
  mutations: {
    setAdminClientList (state, clients) {
      let newClient = [];
      clients.forEach((client, index) => {
        let imgUrl = client;
        imgUrl.img = 'static/img/arrow.png';
        imgUrl.expended = false;
        newClient[index] = imgUrl;
      });
      state.adminClientList = newClient;
      state.currentClient = null;
    },
    setCurrentClient (state, client) {
      state.currentClient = client;
    },
    setClientLoaded (state) {
      state.clientLoaded = !state.clientLoaded;
    },
    setInitialClient (state, client) {
      state.initialClient = Object.assign({}, client);
    },
    resetClient (state) {
      state.adminClientList = [];
      state.currentClient = null;
      state.currentClientName = null;
      state.clientLoaded = false;
      state.initialClient = null;
    },
    toggleCurrentClientIsAnalytics (state, toggled) {
      if (toggled) {
        state.currentClient.isAnalytics = 1;
      } else {
        state.currentClient.isAnalytics = 0;
      }
    }
  },
  actions: {
    async loadClient ({commit}, data) {
      if (data.isAdmin === true) {
        if (data.search === '') {
          let search = 0;
          const clients = await getClientList(search);
          commit('setAdminClientList', clients.data);
        } else {
          let search = data.search;
          const clients = await getClientList(search);
          const dataArr = typeof clients.data === 'string' ? [] : clients.data;
          commit('setAdminClientList', dataArr);
        }
      } else {
        const client = await getClient(data.clientId);
        commit('setCurrentClient', client.data);
      }
    },
    resetClient ({commit}) {
      commit('setCurrentClient', null);
    },
    toggleClientLoadedFlag ({commit}) {
      commit('setClientLoaded');
    },
    unloadClient ({commit}) {
      commit('resetClient');
    },
    loadClientEditor ({commit}, client) {
      commit('setInitialClient', client);
      commit('setCurrentClient', client);
    },
    toggleCurrentClientIsAnalytics ({commit}, toggled) {
      commit('toggleCurrentClientIsAnalytics', toggled);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/clientModule.js